import React from 'react';
 
const MyUserContext = React.createContext();

export default MyUserContext;